import { TableList as TableListComponent } from './TableList.component';
import { connector } from './TableList.connector';

export const TableList = connector(TableListComponent);
